import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App/index";
import * as serviceWorker from "./serviceWorker";
import config from "./config";
import "./assets/scss/style.scss";
import "antd/dist/antd.css";
import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/scss/bootstrap.scss";
import "semantic-ui-css/semantic.min.css";
import { store, persistor } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import Loader from "./App/layout/Loader/index";
import "./i18n";
//import { PublicClientApplication } from "@azure/msal-browser";
//import { MsalProvider } from "@azure/msal-react";
//import { msalConfig } from "./authConfig";

//const msalInstance = new PublicClientApplication(msalConfig);
const useMsAuth = process.env.REACT_APP_USE_MS_AUTH === "true";

const app = useMsAuth ? (
  // <MsalProvider instance={msalInstance}>
  <Provider store={store}>
    <PersistGate loading={<Loader />} persistor={persistor}>
      <BrowserRouter basename={config.basename}>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
) : (
  // </MsalProvider>
  <Provider store={store}>
    <PersistGate loading={<Loader />} persistor={persistor}>
      <BrowserRouter basename={config.basename}>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

ReactDOM.render(app, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
